import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Kennzeichnet eine Cosmos-Lieferung als Pufferlager-Produktion statt
 * echtem SNV-Zulauf (Meeting 22.09.2026, Punkt 8: "Pufferlager-Produktion
 * als Bestellung im System führen"). Bewusst eine eigene, neutrale
 * Warnfarbe (nicht Erfolg/Fehler) - es ist kein Fehlerzustand, sondern eine
 * Herkunftstatsache, dieselbe ruhige Optik wie AuslaufendAbzeichen.jsx.
 */
export default function PufferProduktionAbzeichen() {
    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="puffer-produktion-tip">
                    Cosmos produziert hier für das eigene Pufferlager statt direkt für SNV Weilheim zu liefern -
                    Kapitalbindung, aber kein SNV-Zulauf (zählt nicht in Lieferfähigkeit, Bestellvorschlägen oder
                    Lieferplan).
                </Tooltip>
            }
        >
            <span
                className="badge text-bg-warning-subtle border border-warning-subtle text-warning-emphasis fw-normal ms-1"
                style={{fontSize: ".65rem"}}
            >
                Pufferlager-Produktion
            </span>
        </OverlayTrigger>
    );
}
